import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import AsyncSelect from 'react-select/async';

import Const from '../../util/Constants';

class FieldCity extends React.Component {
  
  constructor(props) {
    super(props);
    this.cities = reactLocalStorage.getObject(Const.Cities);
  }

  onSearch = (text, callback) => {
    let cities = [];
    if(text.length > 2) {
      cities = this.cities.filter(city =>
        city.label.replace(' ', '').toLowerCase().includes(text.replace(' ', '').toLowerCase()));
    }
    callback(cities);
  }

  render() {
    return (
      <AsyncSelect cacheOptions isMulti={this.props.isMulti}
        isClearable={true} loadOptions={this.onSearch}
        onChange={selected => this.props.onCitySelected(selected, this.props.index)}
        value={this.props.defaultValue} />
    );
  }

  static getCityById = cityId => {
    return reactLocalStorage.getObject(Const.Cities).find(
      city => parseInt(city.value) === parseInt(cityId));
  }

  static getCityByName = cityName => {
    if (!cityName) return null;
    return reactLocalStorage.getObject(Const.Cities).find(
      city => city.label.toLowerCase() === cityName.toLowerCase()
    );
  }
}
export default FieldCity;